import React from 'react';

import { PrimaryButton } from '@app/components/button';
import { PURCHASE_TAB_STRINGS } from '@app/components/purchase-form/purchase-form.constants';
import { redirectToLogin } from '@app/components/purchase-form/purchase-form.util';
import { SCROLL_PROGRAM_COURSE } from '@app/constants/scroll-to-ids';

import { PurchaseOverlayContainer } from '../purchase-overlay-container';

const AuthenticatedContent = ({ isAuthenticated, onLogin, onSelect }) => (
	<>
		{isAuthenticated ? (
			<>
				<p className="u-font-family-text course-overlay__help-text">
					You haven&apos;t selected your course exam yet.
					<strong>
						Register for your exam now - it&apos;s the best way to stay on track
						and succeed.
					</strong>
				</p>
				<PrimaryButton onClick={onSelect}>Buy Exam</PrimaryButton>
			</>
		) : (
			<>
				<p className="u-font-family-text course-overlay__help-text">
					You must be logged in to your account to select your course exam.
					<strong>Sign in or create an account to select your exam.</strong>
				</p>

				<PrimaryButton onClick={() => onLogin()}>Sign In</PrimaryButton>
			</>
		)}
	</>
);

export const PurchaseMaterialsOverlay = ({
	courseCode,
	hasMatchingCartItem,
	isAuthenticated,
	isSingleForm,
	loginUrl,
	onClose,
	onSelect,
	setContainerHeight,
	show,
	title,
}) => {
	const onLogin = () => {
		redirectToLogin(loginUrl, `${SCROLL_PROGRAM_COURSE}-${courseCode}`);
		localStorage.setItem(
			'purchaseMaterialsForm',
			JSON.stringify({ openOverlayCode: courseCode, storedTitle: title }),
		);
	};

	return (
		<PurchaseOverlayContainer
			show={show}
			title={title}
			onClose={onClose}
			showCartButton={!hasMatchingCartItem}
			setContainerHeight={setContainerHeight}
			tabType={PURCHASE_TAB_STRINGS.MATERIAL_TAB.id}
		>
			{hasMatchingCartItem || isSingleForm ? (
				<>
					<p>
						If you need to update this information, you can do so in the cart.
					</p>

					<a href="/cart" className="btn btn--primary" title="Cart">
						Continue to Cart
					</a>
				</>
			) : (
				<AuthenticatedContent
					isAuthenticated={isAuthenticated}
					onLogin={onLogin}
					onSelect={onSelect}
				/>
			)}
		</PurchaseOverlayContainer>
	);
};
